import { h } from 'preact';
import { Link } from 'preact-router/match'


import './SiteFooter.scss';

const SiteFooter = () => (
    <footer class="site-footer">
        <Link href="/kapcsolat">Impresszum</Link>&nbsp;
        &mdash;
        &copy; {new Date().getFullYear()} &mdash; Minden jog fenntartva. jogitanacs.info
    </footer>
);

export default SiteFooter;


// WEBPACK FOOTER //
// ./src/components/SiteFooter.js